import { useEffect, useState } from 'react';
import SocketConnection from './utils/SocketConnection';
import { Socket } from 'socket.io-client';

// live:
const WEBSOCKET_1_ENDPOINT = 'wss://play.livescape.tv:9002';
const WEBSOCKET_2_ENDPOINT = 'wss://play.livescape.tv:9003';

// testing:
// const WEBSOCKET_1_ENDPOINT = 'wss://localhost:9002';
// const WEBSOCKET_2_ENDPOINT = 'wss://localhost:9003';

function HostView() {

  const [ hostViewUrl, setHostViewUrl ] = useState('');

  //Mirror gamer result
  const [canvas1Data, setCanvas1Data] = useState(null);
  const [canvas2Data, setCanvas2Data] = useState(null);
  useEffect(() => {
    const websocket1 = new WebSocket(WEBSOCKET_1_ENDPOINT);
    websocket1.addEventListener('message', (event) => {
      //Check if data is image
      if (event.data.substring(0, 10) == 'data:image') {
        setCanvas1Data(event.data)
      } else {
        const message = JSON.parse(event.data)
        if (message.action == "add") {
          if (document.getElementById(message.id) == null) {
            const content1 = document.getElementById('content1')
            content1.innerHTML = content1.innerHTML + message.content
          }
        }
        if (message.action == "remove") {
          if (document.getElementById(message.id) != null) {
            document.getElementById(message.id).remove()
          }
        }
        if (message.action == "score") {
          if (document.getElementById('livescore1') == null) {
            const content1 = document.getElementById('content1')
            content1.innerHTML = content1.innerHTML + '<div id="livescore1" class="livescore"> ' + message.content + '</div>'
          } else {
            document.getElementById('livescore1').innerHTML = message.content
          }
        }
        if (message.action == "konami_button_press") {
          const content1 = document.getElementById('content1');
          if (content1.querySelector(`.overlay > .buttons`)) {
            const buttons = content1.querySelector(`.overlay > .buttons`).childNodes;
            if (buttons && buttons[message.content]) {
              buttons[message.content].classList.add('pressed');
              setTimeout(() => {
                buttons[message.content].classList.remove('pressed');
              }, 200); // Duration of the effect
            }
            // message.content is the button index
          }
        }
        if (message.action == "konami_display_victory") {
          const content1 = document.getElementById('content1');
          content1.querySelector('div.image').style.display = 'none';
          content1.querySelector('div.overlay').style.display = 'none';
          content1.querySelector('div.success').style.display = 'block';
          content1.querySelector('img.victorygif').style.display = 'block';
        }
        if (message.action == "konami_display_defeat") {
          const content1 = document.getElementById('content1');
          content1.querySelector('div.image').style.display = 'none';
          content1.querySelector('div.overlay').style.display = 'none';
          content1.querySelector('div.success').style.display = 'block';
          content1.querySelector('img.defeatgif').style.display = 'block';
        }
      }
    })
    const websocket2 = new WebSocket(WEBSOCKET_2_ENDPOINT);
    websocket2.addEventListener('message', (event) => {
      //Check if data is image
      if (event.data.substring(0, 10) == 'data:image') {
        setCanvas2Data(event.data)
      } else {
        const message = JSON.parse(event.data)
        if (message.action == "add") {
          const content2 = document.getElementById('content2')
          if (document.getElementById(message.id) == null) {
            content2.innerHTML = content2.innerHTML + message.content
          }
        }
        if (message.action == "remove") {
          if (document.getElementById(message.id) != null) {
            document.getElementById(message.id).remove()
          }
        }
        if (message.action == "score") {
          if (document.getElementById('livescore2') == null) {
            const content2 = document.getElementById('content2')
            content2.innerHTML = content2.innerHTML + '<div id="livescore2" class="livescore"> ' + message.content + '</div>'
          } else {
            document.getElementById('livescore2').innerHTML = message.content
          }
        }
        if (message.action == "konami_button_press") {
          const content2 = document.getElementById('content2');
          if (content2.querySelector(`.overlay > .buttons`)) {
            const buttons = content2.querySelector(`.overlay > .buttons`).childNodes;
            if (buttons && buttons[message.content]) {
              buttons[message.content].classList.add('pressed');
              setTimeout(() => {
                buttons[message.content].classList.remove('pressed');
              }, 200); // Duration of the effect
            }
            // message.content is the button index
          }
        }
        if (message.action == "konami_display_victory") {
          const content2 = document.getElementById('content2');
          content2.querySelector('div.image').style.display = 'none';
          content2.querySelector('div.overlay').style.display = 'none';
          content2.querySelector('div.success').style.display = 'block';
          content2.querySelector('img.victorygif').style.display = 'block';
        }
        if (message.action == "konami_display_defeat") {
          const content2 = document.getElementById('content2');
          content2.querySelector('div.image').style.display = 'none';
          content2.querySelector('div.overlay').style.display = 'none';
          content2.querySelector('div.success').style.display = 'block';
          content2.querySelector('img.defeatgif').style.display = 'block';
        }
      }
    })
  },[])

  useEffect(() => {
    if (!SocketConnection.connected && !SocketConnection.connecting) {
      // connect as the host
      SocketConnection.connect('host');
    }
  }, []);


  const handleMinigameSelection = (minigame) => {
    // document.getElementById('content1').remove()
    // document.getElementById('content2').remove()
    document.getElementById('content1').innerHTML =''
    document.getElementById('content2').innerHTML =''
    setCanvas1Data(null)
    setCanvas2Data(null)
     
    if (minigame !== '') {
      SocketConnection.startMinigame(minigame);
    } else {
      SocketConnection.closeMinigame();
    }
  };


  const handleHostViewUrlChange = (e) => {
    e.preventDefault();
    SocketConnection.setHostViewUrl(hostViewUrl);
    return false;
  };


  return (
    <div className="container__flex">
        <div className="flex__wrap--col">
          <div className="block__container" style={{backgroundColor: '#a8ff4d', position: 'relative'}}>
            <div id="content1"></div>
            {canvas1Data && <div style={{backgroundColor: 'white'}}><img width="100%" height="100%" src={canvas1Data} alt="Canvas1"/></div>}
          </div>
          <div className="block__container" style={{backgroundColor: '#f769d9', position: 'relative'}}>
            <div id="content2"></div>
            {canvas2Data && <div style={{backgroundColor: 'white'}}><img width="100%" height="100%" src={canvas2Data} alt="Canvas2"/></div>}
          </div>
        </div>
        <div className="sidebar">
          <div className="radio-container">

            <h3>Mini Game</h3>

            <div className="radio-item">
              <input type="radio" name="minigame" onClick={() => handleMinigameSelection('')}/>
              <label htmlFor="option1">[ OFF ]</label>
            </div>

            <div className="radio-item">
              <input type="radio" name="minigame" onClick={() => handleMinigameSelection('konami')}/>
              <label htmlFor="option2">Konami</label>
            </div>

            <div className="radio-item">
              <input type="radio" name="minigame" onClick={() => handleMinigameSelection('popups')}/>
              <label htmlFor="option3">Popups</label>
            </div>

            <div className="radio-item">
              <input type="radio" name="minigame" onClick={() => handleMinigameSelection('paint')}/>
              <label htmlFor="option4">Paint</label>
            </div>

            <h3>Host Feed</h3>

            <div className="vdoninja-url">
              <label>VDO Ninja URL
                <input type="text" name="vdoninja" value={hostViewUrl} onChange={(e) => { setHostViewUrl(e.target.value)}}/>
                <button onClick={handleHostViewUrlChange}>Save</button>
              </label>
            </div>
          </div>
        </div>
      </div>
  );
}

export default HostView;
